import { defineMessage } from 'services/localization';

export const messages = {
    buttonText: defineMessage('choose_your_plan'),
    text: defineMessage('usecase_starting_from_price_per_month'),
    description: defineMessage('businesses_are_doing_it_faster_with_approvalmax'),
    expiredTrialUseCaseDefault: defineMessage('strengthen_your_internal_financial_controls'),
    expiredTrialUseCaseStreamlineAuditProcesses: defineMessage('streamline_audit_processes_1'),
    expiredTrialUseCaseEstablishInternalFinancialControls: defineMessage('establish_internal_financial_controls_1'),
    expiredTrialUseCaseAutomateApprovalWorkflows: defineMessage('automate_approval_workflows_1'),
    expiredTrialUseCaseSpeedupTheApprovalProcess: defineMessage('speed_up_the_approval_process_1'),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControls: defineMessage(
        'streamline_audits_and_establish_financial_controls'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndAutomateApprovalWorkflows: defineMessage(
        'streamline_audits_and_automate_approvals'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndSpeedupTheApprovalProcess: defineMessage(
        'streamline_the_approvals_and_audits'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflows: defineMessage(
        'establish_financial_con_ith_approval_automation'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess: defineMessage(
        'establish_financial_con__and_speed_up_approvals_1'
    ),
    expiredTrialUseCaseAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'speed_up_the_approval_process_with_automation'
    ),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndAutomateApprovalWorkflows:
        defineMessage('establish_financial_con_ng_approvals_and_audits'),
    expiredTrialUseCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess:
        defineMessage('establish_financial_con__and_automate_approvals_1'),
    expiredTrialUseCaseStreamlineAuditProcessesAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'streamline_your_audits__provals_with_automation'
    ),
    expiredTrialUseCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess:
        defineMessage('establish_financial_con_provals_with_automation_1'),
};
